import { useFeedbackOptions } from "./useFeedbackOptions";
import { useCreateFeedback } from "./useCreateFeedback";
import { useUpdateFeedback } from "./useUpdateFeedback";

export function useContextFeedback(threadId: string) {
  const { feedbackOptions, isLoadingOptions } = useFeedbackOptions();
  const createMutation = useCreateFeedback(threadId);
  const updateMutation = useUpdateFeedback(threadId);

  const submitThumbsUp = () => {
    createMutation.mutate({ thread_id: threadId, rating: "thumbs_up" });
  };

  const submitThumbsDown = () => {
    createMutation.mutate({
      thread_id: threadId,
      rating: "thumbs_down",
    });
  };

  const submitReasons = (reasons: string[], comment: string) => {
    updateMutation.mutate({
      reasons,
      ...(comment ? { comment } : {}),
    });
  };

  return {
    feedbackOptions,
    isLoadingOptions,
    submitThumbsUp,
    submitThumbsDown,
    submitReasons,
    isSubmitting: createMutation.isPending || updateMutation.isPending,
  };
}
